import MemberBadge from '@my-pages/components/MemberBadge.tsx';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import {Link, useLocation} from "@tanstack/react-router";
import useGetGlobalSiteSettings from "@shared/features/global-site-settings/hooks/useGetGlobalSiteSettings.ts";

export const Header = () => {

    const location = useLocation()  
    const {loginUrl} = useGetGlobalSiteSettings();
    const isAuthenticated = useApplicationStore((state) => state.isAuthenticated);

    return (
        <>
            <header className='site-header fade-in-medium p-3'>
                <Logo />
                {isAuthenticated ?<> <MemberBadge /> <button
                    type='button'
                    className='btn btn-light btn-mobile-nav'
                    onClick={() => $('body').toggleClass('is-nav-mobile-active')}
                >
                    <div className='btn-mobile-nav-inner'></div>
                </button></> :loginUrl && !location.pathname.includes(loginUrl) ?  <Link className="btn btn-light slide-down-fade-in" to={"/$"} params={{_splat:loginUrl}}>Logga in</Link> : null}
            </header>
        </>
    );
};

export const Logo = () => {
    return (
        <Link
            to='/$' params={{_splat:"/"}}
            className='lockup p-0'
        >
            <span className='logo-transport'></span>
            <span className='brand'>Transport</span>
        </Link>
    );
};

export default Header;
